<template>
    <flex-element
        v-plaintext
        class="f-break-words"
        class-default-inline="f-block"
        :tag="renderTag"
        :element-type="elementType"
    >
        <span v-if="previewMode">
            {{ renderTextPreview }}
        </span>

        <span
            v-else
            v-text-select="singleLineTextNew"
            :contenteditable="isContentEditable"
            @input="setChangedData(true)"
            @blur="onInput"
        />
    </flex-element>
</template>

<script>
import baseAtom from '@/mixins/base-atom/base-atom-smart';
import { AHeading } from '@/data/data-models';

const PLACEHOLDER_TEXT = '[Text here]';

export default {
    name: 'a-heading',
    mixins: [baseAtom],

    props: {
        displayName: {
            type: String,
            default: 'Heading',
        },

        singleLineText: {
            type: String,
            default: '',
        },

        tag: {
            type: String,
            default: '',
        },

        tagDefault: {
            type: String,
            default: 'h1',
        },

        templateId: {
            type: String,
            default: '{71F17ED8-3218-46E2-80A6-277E74F0502B}',
        },
    },

    data() {
        return {
            cssDisplay: 'block',
            singleLineTextNew: '',
            tagNew: '',
        };
    },

    computed: {
        renderTextPreview() {
            if (this.singleLineTextNew === PLACEHOLDER_TEXT) {
                return '';
            }
            return this.singleLineTextNew;
        },

        renderTag() {
            return this.tagNew || this.tagDefault;
        },

        updatedElement() {
            return new AHeading({
                ...this.updatedBaseElement,
                singleLineText: this.singleLineTextNew === PLACEHOLDER_TEXT ? '' : this.singleLineTextNew,
                tag: this.renderTag,
            });
        },
    },

    methods: {
        setFieldValues() {
            // TODO: fails on insert, look for better slot check
            // if (this.$slots.default.length > 1) {
            //     console.warn(`${ this.name } should not have multiple elements within slot.`);
            //     return;
            // }
            this.singleLineTextNew = this.singleLineText
                || (this.$slots.default ? this.$slots.default[0].text.trim() : PLACEHOLDER_TEXT);
            this.tagNew = this.tag;
        },

        onInput(e) {
            this.singleLineTextNew = e.target.innerText;
        },
    },
};
</script>
